import { createElement } from 'react';

const CHARACTER_STAGGER_DELAY = 0.01;

function AnimatedCharacters({ label }) {
  return (
    <span
      data-button-animate-chars
      className='btn__text'
      aria-hidden='true'
    >
      {Array.from(label).map((char, index) => (
        <span
          key={`${char}-${index}`}
          style={{
            transitionDelay: `${index * CHARACTER_STAGGER_DELAY}s`,
            whiteSpace: char === ' ' ? 'pre' : undefined,
          }}
        >
          {char}
        </span>
      ))}
    </span>
  );
}

function PrimaryButton({
  as = 'button',
  label,
  icon,
  tone = 'dark',
  className = '',
  type,
  ...props
}) {
  const Component = as;
  const buttonProps = {
    ...props,
    className: [
      'btn',
      tone === 'light' ? 'btn--light' : '',
      icon ? 'btn--with-icon' : '',
      className,
    ]
      .filter(Boolean)
      .join(' '),
    'aria-label': props['aria-label'] ?? label,
  };

  if (Component === 'button') {
    buttonProps.type = type ?? 'button';
  }

  return createElement(
    Component,
    buttonProps,
    <>
      <span className='btn__bg' aria-hidden='true'></span>
      <span className='btn__content'>
        {icon ? (
          <span className='btn__icon' aria-hidden='true'>
            {icon}
          </span>
        ) : null}
        <AnimatedCharacters label={label} />
      </span>
    </>
  );
}

export default PrimaryButton;
